import React,{useEffect,useState} from 'react'
import ThreeColumProfile from '../../layouts/ThreeColumProfile'
import InputProfile from '../../components/InputProfile'
import moon from '../../images/Svg/moon.svg'
import BigHeads from '../../components/BigHeads'

import api from '../../services/api'

import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';


const Profile = () => {

    const [name,setName] = useState()
    const [surName,setSurName] = useState()
    const [password,setPassword] = useState()
    const [picture,setPicture] = useState()

    const [passwordError,setPasswordError] = useState()


    const [mail,setMail] = useState()
    const [id,setId] = useState()

    const getData = async () => {

        const mail = localStorage.getItem("@MAIL")
        const response = await api.get(`client/user/${mail}`)
        
        setName(response.data[0].name)
        setMail(response.data[0].mail)
        setId(response.data[0].id)
        setSurName(response.data[0].surname)
        setPicture(response.data[0].picture)

        localStorage.setItem("@USER_PICTURE",response.data[0].picture)

    }
    const updateMail = async () => {

      var re = /\S+@\S+\.\S+/;
      const validateMail =  re.test(mail);

      if(validateMail == false){

        toast.error('email inválido!', {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          });

          setTimeout(() => {

            window.location.href="/profile"

          },[2000])

        return false
      }
      

        toast.success('email alterado com sucesso!', {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            
            progress: undefined,
            theme: "light",
          });

        const response = await api.put("client/user",{

            mail:localStorage.getItem("@MAIL"),
            newMail:mail,
            id:id
        })

        localStorage.setItem("@MAIL",mail)


    }
    const updateName = async () => {

      if(name == undefined || name == "" ){

        toast.error('nome inválido', {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          });

          setTimeout(() => {

            window.location.href="/profile"

          },[2000])

          
          return false

      }

        toast.success('nome alterado com sucesso!', {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            
            progress: undefined,
            theme: "light",
          });

        const response = await api.put("client/user/name",{

            name:name,
            surname:surName,
            id:id
        })

        
        setTimeout(() => {

          window.location.href="/profile"

        },[2000])

        localStorage.setItem("@MAIL",mail)


    }
    const updatePassword = async () => {
      
      if(password == undefined){

        toast.error('senha deve ter pelo menos 8 caracteres', {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          });

          setTimeout(() => {

            window.location.href="/profile"

          },[2000])

        return false

        
      }

      if(String(password).length < 8){

        toast.error('senha deve ter mais de 8 caracteres', {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          });


        return false
      }


        toast.success('senha alterada com sucesso!', {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            
            progress: undefined,
            theme: "light",
          });

          

        const response = await api.put("client/user/password",{

            password_hash:password,
            id:id
        })

        localStorage.setItem("@MAIL",mail)


    }
    async function getBase64(file) {

      
        const types = ["image/png","image/jpg"]
  
        if(file.type == types[0] || types[1] || types[2] || types[3]){
  
          console.log("correct")
  
        }else{

            alert("Formato de arquivo inválido")
            return false

        }
  
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function () {
  
          setPicture(reader.result)
          localStorage.setItem("@USER_PICTURE",reader.result)


        const response = await api.put("client/user/picture",{

            picture:reader.result,
            id:id
        })

        toast.success('Foto alterada com sucesso!', {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          
          progress: undefined,
          theme: "light",
        });


        window.location.href="/profile"
  
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
        };
  
        
    }
    
    useEffect(() =>{

        getData()

    },[])
    useEffect(() => {

      
      if(String(password).length > 0){

        if(String(password).length < 8){

            setPasswordError("senha deve ter pelo menos 8 caracteres")

        }else{

          setPasswordError()

        }

    }

    },[password])


    return(

        <ThreeColumProfile
        page="profile"
        colum2Data={

                    
        <div style={{display:"flex",height:"90vh",width:"100%",paddingTop:"5.4rem",justifyContent:"space-between"}}>

        <ToastContainer />


        <div style={{width:"460px",height:"269px",border:"1px solid #D7D7D7",borderRadius:"15px",paddingLeft:"2.063rem",paddingTop:"1.563rem"}}>
        <p className="textNameProfile">Foto de perfil</p>

        <div style={{display:"flex",alignItems:"center"}}>
        
        <div style={{width:"125px",height:"125px",borderRadius:"100%",border:"1px solid #D7D7D7",display:"flex",flexDirection:"column",alignItems:"center"}}>
        
        {picture != undefined 
        
        
        ?
        <img  src={"data:image/;base64;"+ picture } style={{width:"118px",height:"100%",borderRadius:"100%",objectFit:"cover"}}/>
        :
        <BigHeads width={108} />
        
        }

        </div>

        
        <input type="file" id="file"  onChange={(e) => getBase64(e.target.files[0])} accept='image/png, image/jpg' name='file' style={{display:"none"}}/>

        <label htmlFor='file' className="textBtnUploadImage" style={{border:"none",background:"#1172EB",width:"198.32px",height:"43px",marginLeft:"3.18rem",borderRadius:"60px"}}>
        <p style={{textAlign:"center",marginTop:"10px"}}>Upload foto</p>
   
        </label>

        </div>


        </div>

        <div style={{display:"flex",flexDirection:"column",paddingRight:"2.063rem"}}>
        <div style={{width:"662px",height:"269px",border:"1px solid #D7D7D7",borderRadius:"15px",paddingTop:"1.87rem",paddingLeft:"1.87rem",paddingBottom:"30px"}}>

        <p className="textAcessDataProfile">Dados de acesso</p>
        
        <div style={{display:"flex",alignItems:"center"}}>

        <div>
        <InputProfile maxLength={15}  onChange={(e) => setName(e.target.value)}  onBlur={() => updateName()} name="Nome" value={name}/>
        <InputProfile onChange={(e => setMail(e.target.value))}  onBlur={() => updateMail()} name="E-mail de acesso" value={mail}/>
        </div>

        <div>
        <InputProfile name="Sobrenome" onBlur={() => updateName()} onChange={(e) => setSurName(e.target.value)} value={surName}/>
        <InputProfile error={passwordError} messageError={passwordError} type={"password"} onBlur={() => updatePassword()} onChange={(e) => setPassword(e.target.value)} name="Senha de acesso"/>
        
        </div>


        </div>



        </div>
        
        <div style={{width:"662px",height:"345px",border:"1px solid #D7D7D7",marginTop:"2.25rem",borderRadius:"15px",paddingLeft:"1.43rem",paddingRight:"1.43rem",paddingTop:"1.56rem"}}>
        
        <div style={{display:"flex",justifyContent:"space-between"}}>
        <p className="textchargeProfile">Notas fiscais & Cobranças</p>

        <div>
        <svg width="95" height="27" viewBox="0 0 95 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="95" height="27" rx="13.5" fill="#FFF7AA"/>
        <path d="M21.4985 18C21.3225 18 21.1745 17.94 21.0545 17.82C20.9345 17.7 20.8745 17.552 20.8745 17.376V9.252C20.8745 9.068 20.9345 8.92 21.0545 8.808C21.1745 8.688 21.3225 8.628 21.4985 8.628H26.9225C27.1065 8.628 27.2545 8.684 27.3665 8.796C27.4785 8.9 27.5345 9.04 27.5345 9.216C27.5345 9.384 27.4785 9.52 27.3665 9.624C27.2545 9.728 27.1065 9.78 26.9225 9.78H22.1225V12.696H25.5665C25.7505 12.696 25.8985 12.752 26.0105 12.864C26.1225 12.968 26.1785 13.104 26.1785 13.272C26.1785 13.44 26.1225 13.58 26.0105 13.692C25.8985 13.796 25.7505 13.848 25.5665 13.848H22.1225V16.848H26.9225C27.1065 16.848 27.2545 16.9 27.3665 17.004C27.4785 17.108 27.5345 17.244 27.5345 17.412C27.5345 17.588 27.4785 17.732 27.3665 17.844C27.2545 17.948 27.1065 18 26.9225 18H21.4985ZM37.4395 18.012C37.2635 18.012 37.1155 17.956 36.9955 17.844C36.8835 17.724 36.8275 17.576 36.8275 17.4V13.968C36.8275 13.464 36.7035 13.092 36.4555 12.852C36.2075 12.604 35.8835 12.48 35.4835 12.48C35.0675 12.48 34.7235 12.624 34.4515 12.912C34.1875 13.2 34.0555 13.568 34.0555 14.016H33.0595C33.0595 13.496 33.1715 13.04 33.3955 12.648C33.6195 12.248 33.9315 11.936 34.3315 11.712C34.7395 11.488 35.2035 11.376 35.7235 11.376C36.1795 11.376 36.5835 11.476 36.9355 11.676C37.2875 11.876 37.5595 12.172 37.7515 12.564C37.9515 12.948 38.0515 13.416 38.0515 13.968V17.4C38.0515 17.576 37.9955 17.724 37.8835 17.844C37.7715 17.956 37.6235 18.012 37.4395 18.012ZM29.4355 18.012C29.2595 18.012 29.1115 17.956 28.9915 17.844C28.8795 17.724 28.8235 17.576 28.8235 17.4V12.06C28.8235 11.876 28.8795 11.728 28.9915 11.616C29.1115 11.504 29.2595 11.448 29.4355 11.448C29.6195 11.448 29.7675 11.504 29.8795 11.616C29.9915 11.728 30.0475 11.876 30.0475 12.06V17.4C30.0475 17.576 29.9915 17.724 29.8795 17.844C29.7675 17.956 29.6195 18.012 29.4355 18.012ZM33.4435 18.012C33.2675 18.012 33.1195 17.956 32.9995 17.844C32.8875 17.724 32.8315 17.576 32.8315 17.4V13.968C32.8315 13.464 32.7075 13.092 32.4595 12.852C32.2115 12.604 31.8875 12.48 31.4875 12.48C31.0715 12.48 30.7275 12.624 30.4555 12.912C30.1835 13.2 30.0475 13.568 30.0475 14.016H29.2915C29.2915 13.496 29.3955 13.04 29.6035 12.648C29.8115 12.248 30.0995 11.936 30.4675 11.712C30.8355 11.488 31.2555 11.376 31.7275 11.376C32.1835 11.376 32.5875 11.476 32.9395 11.676C33.2915 11.876 33.5635 12.172 33.7555 12.564C33.9555 12.948 34.0555 13.416 34.0555 13.968V17.4C34.0555 17.576 33.9995 17.724 33.8875 17.844C33.7755 17.956 33.6275 18.012 33.4435 18.012ZM46.2342 18.048C45.6102 18.048 45.0502 17.904 44.5542 17.616C44.0582 17.32 43.6662 16.92 43.3782 16.416C43.0902 15.912 42.9422 15.344 42.9342 14.712V9.24C42.9342 9.056 42.9902 8.908 43.1022 8.796C43.2222 8.684 43.3702 8.628 43.5462 8.628C43.7302 8.628 43.8782 8.684 43.9902 8.796C44.1022 8.908 44.1582 9.056 44.1582 9.24V12.48C44.4382 12.144 44.7742 11.88 45.1662 11.688C45.5662 11.488 46.0022 11.388 46.4742 11.388C47.0582 11.388 47.5822 11.536 48.0462 11.832C48.5102 12.12 48.8742 12.516 49.1382 13.02C49.4102 13.516 49.5462 14.08 49.5462 14.712C49.5462 15.344 49.3982 15.912 49.1022 16.416C48.8142 16.92 48.4222 17.32 47.9262 17.616C47.4302 17.904 46.8662 18.048 46.2342 18.048ZM46.2342 16.968C46.6422 16.968 47.0062 16.872 47.3262 16.68C47.6462 16.48 47.8982 16.208 48.0822 15.864C48.2742 15.52 48.3702 15.136 48.3702 14.712C48.3702 14.28 48.2742 13.896 48.0822 13.56C47.8982 13.224 47.6462 12.96 47.3262 12.768C47.0062 12.568 46.6422 12.468 46.2342 12.468C45.8342 12.468 45.4702 12.568 45.1422 12.768C44.8222 12.96 44.5702 13.224 44.3862 13.56C44.2022 13.896 44.1102 14.28 44.1102 14.712C44.1102 15.136 44.2022 15.52 44.3862 15.864C44.5702 16.208 44.8222 16.48 45.1422 16.68C45.4702 16.872 45.8342 16.968 46.2342 16.968ZM51.6263 13.896C51.6263 13.416 51.7423 12.988 51.9743 12.612C52.2143 12.228 52.5343 11.924 52.9343 11.7C53.3343 11.476 53.7743 11.364 54.2543 11.364C54.7343 11.364 55.0903 11.444 55.3223 11.604C55.5623 11.756 55.6543 11.94 55.5983 12.156C55.5743 12.268 55.5263 12.356 55.4543 12.42C55.3903 12.476 55.3143 12.512 55.2263 12.528C55.1383 12.544 55.0423 12.54 54.9383 12.516C54.4263 12.412 53.9663 12.404 53.5583 12.492C53.1503 12.58 52.8263 12.744 52.5863 12.984C52.3543 13.224 52.2383 13.528 52.2383 13.896H51.6263ZM51.6383 18C51.4463 18 51.2983 17.952 51.1943 17.856C51.0903 17.752 51.0383 17.6 51.0383 17.4V12.036C51.0383 11.844 51.0903 11.696 51.1943 11.592C51.2983 11.488 51.4463 11.436 51.6383 11.436C51.8383 11.436 51.9863 11.488 52.0823 11.592C52.1863 11.688 52.2383 11.836 52.2383 12.036V17.4C52.2383 17.592 52.1863 17.74 52.0823 17.844C51.9863 17.948 51.8383 18 51.6383 18ZM59.1445 18.048C58.4805 18.048 57.8885 17.908 57.3685 17.628C56.8565 17.34 56.4525 16.948 56.1565 16.452C55.8685 15.948 55.7245 15.372 55.7245 14.724C55.7245 14.068 55.8605 13.492 56.1325 12.996C56.4125 12.492 56.7965 12.1 57.2845 11.82C57.7725 11.532 58.3325 11.388 58.9645 11.388C59.5885 11.388 60.1245 11.528 60.5725 11.808C61.0205 12.08 61.3605 12.46 61.5925 12.948C61.8325 13.428 61.9525 13.984 61.9525 14.616C61.9525 14.768 61.9005 14.896 61.7965 15C61.6925 15.096 61.5605 15.144 61.4005 15.144H56.5645V14.184H61.3645L60.8725 14.52C60.8645 14.12 60.7845 13.764 60.6325 13.452C60.4805 13.132 60.2645 12.88 59.9845 12.696C59.7045 12.512 59.3645 12.42 58.9645 12.42C58.5085 12.42 58.1165 12.52 57.7885 12.72C57.4685 12.92 57.2245 13.196 57.0565 13.548C56.8885 13.892 56.8045 14.284 56.8045 14.724C56.8045 15.164 56.9045 15.556 57.1045 15.9C57.3045 16.244 57.5805 16.516 57.9325 16.716C58.2845 16.916 58.6885 17.016 59.1445 17.016C59.3925 17.016 59.6445 16.972 59.9005 16.884C60.1645 16.788 60.3765 16.68 60.5365 16.56C60.6565 16.472 60.7845 16.428 60.9205 16.428C61.0645 16.42 61.1885 16.46 61.2925 16.548C61.4285 16.668 61.5005 16.8 61.5085 16.944C61.5165 17.088 61.4525 17.212 61.3165 17.316C61.0445 17.532 60.7045 17.708 60.2965 17.844C59.8965 17.98 59.5125 18.048 59.1445 18.048ZM65.1659 17.988C64.9179 17.988 64.7259 17.856 64.5899 17.592L62.0459 12.228C61.9819 12.092 61.9739 11.96 62.0219 11.832C62.0779 11.696 62.1819 11.592 62.3339 11.52C62.4699 11.448 62.6059 11.436 62.7419 11.484C62.8859 11.532 62.9939 11.624 63.0659 11.76L65.4419 16.884H64.8659L67.2179 11.76C67.2899 11.624 67.3979 11.532 67.5419 11.484C67.6939 11.436 67.8459 11.448 67.9979 11.52C68.1419 11.584 68.2379 11.684 68.2859 11.82C68.3339 11.956 68.3259 12.092 68.2619 12.228L65.7179 17.592C65.5979 17.856 65.4139 17.988 65.1659 17.988ZM72.0364 18.048C71.3724 18.048 70.7804 17.908 70.2604 17.628C69.7484 17.34 69.3444 16.948 69.0484 16.452C68.7604 15.948 68.6164 15.372 68.6164 14.724C68.6164 14.068 68.7524 13.492 69.0244 12.996C69.3044 12.492 69.6884 12.1 70.1764 11.82C70.6644 11.532 71.2244 11.388 71.8564 11.388C72.4804 11.388 73.0164 11.528 73.4644 11.808C73.9124 12.08 74.2524 12.46 74.4844 12.948C74.7244 13.428 74.8444 13.984 74.8444 14.616C74.8444 14.768 74.7924 14.896 74.6884 15C74.5844 15.096 74.4524 15.144 74.2924 15.144H69.4564V14.184H74.2564L73.7644 14.52C73.7564 14.12 73.6764 13.764 73.5244 13.452C73.3724 13.132 73.1564 12.88 72.8764 12.696C72.5964 12.512 72.2564 12.42 71.8564 12.42C71.4004 12.42 71.0084 12.52 70.6804 12.72C70.3604 12.92 70.1164 13.196 69.9484 13.548C69.7804 13.892 69.6964 14.284 69.6964 14.724C69.6964 15.164 69.7964 15.556 69.9964 15.9C70.1964 16.244 70.4724 16.516 70.8244 16.716C71.1764 16.916 71.5804 17.016 72.0364 17.016C72.2844 17.016 72.5364 16.972 72.7924 16.884C73.0564 16.788 73.2684 16.68 73.4284 16.56C73.5484 16.472 73.6764 16.428 73.8124 16.428C73.9564 16.42 74.0804 16.46 74.1844 16.548C74.3204 16.668 74.3924 16.8 74.4004 16.944C74.4084 17.088 74.3444 17.212 74.2084 17.316C73.9364 17.532 73.5964 17.708 73.1884 17.844C72.7884 17.98 72.4044 18.048 72.0364 18.048Z" fill="#C6B200"/>
        </svg>
        </div>

        </div>

        <div style={{display:"flex",justifyContent:"center",alignItems:"center",marginBottom:"30px"}}>
        <img src={moon}/>
        </div>

        <div>
            
        </div>
        </div>
        </div>
        </div>
        }
        >
        


        </ThreeColumProfile>

    )

}

export default Profile